import React from "react";

import { minutesToLabel } from "../minutesToLabel";
import { bodyTextStyle } from "./bodyTextStyle";

export default ({ node }) => {
  return (
    <div style={bodyTextStyle}>
      Send between {minutesToLabel(node.node_data.start_minute)} – {minutesToLabel(node.node_data.end_minute)}
    </div>
  );
};
